/**
 * @summary This class is used to regular expression validation
 */
export class RegExpValidator {
    /**
     * @summary  This is a static function used to validate regular expression
     * @param pattern [string] regular expression
     * @param value [string] value should be validated
     * @returns {boolean} return true if pattern exists in a searched string else return false
     */
    static isValid(pattern, value) {
        const regEx = new RegExp(pattern);
        return regEx.test(value);
    }
}
//# sourceMappingURL=RegExpValidator.js.map